class sliderSection {
    constructor(element, options = {}){
        this.options = Object.assign(
            {},
            {  
                slideDesk : 4,
                slideDeskInc : 1,
                slideMob : 2,
                slideMobInc : 2,
                ruptDeskMob : 992,
                class_child: ".slide",
                class_parent_slider: ".slider",
                cursor: false
            }, 
            options
        );    
        this.slider = element;  
        this.sliderLeft = this.slider.querySelector(".arrow.left");
        this.sliderRight = this.slider.querySelector(".arrow.right");
        this.nbSlide = element.querySelectorAll(this.options.class_child).length;  
        this.currentSlide = 0;  
        this.saveTransition = this.slider.querySelector(this.options.class_parent_slider).style.transition;

        this.bullets = element.querySelectorAll(".bullet"); 

        if(this.nbSlide == 1){
            this.sliderRight.classList.add("off");
            this.sliderLeft.classList.add("off");
        }

        window.addEventListener("resize", () => {
            this.reset();
        });

        if(this.nbSlide > 1){
            //this.gotoStep(this.currentSlide); 

            this.sliderRight.addEventListener("click", () => {
                this.currentSlide += this.inc;
                this.gotoStep(this.currentSlide);
            });

            this.sliderLeft.addEventListener("click", () => {
                this.currentSlide -= this.inc;  
                this.gotoStep(this.currentSlide);
            });
        }

        
        
    }

    gotoStep(step){  
        let min = 0;
        let max = this.nbSlide - this.slidesVisible;   
        if(step <= 0){
            this.currentSlide = 0;
            if(this.sliderRight.classList.contains("off")){
                this.sliderRight.classList.remove("off");
            } 
            if(!this.sliderLeft.classList.contains("off")){
                this.sliderLeft.classList.add("off");
            } 
        }
        if(step > 0){
            if(step >= max){
                this.currentSlide = max;
                if(!this.sliderRight.classList.contains("off")){
                    this.sliderRight.classList.add("off");
                } 
                if(this.sliderLeft.classList.contains("off")){
                    this.sliderLeft.classList.remove("off");
                } 
            }else{
                this.currentSlide = step;
                if(this.sliderRight.classList.contains("off")){
                    this.sliderRight.classList.remove("off");
                }
                if(this.sliderLeft.classList.contains("off")){
                    this.sliderLeft.classList.remove("off")
                } 
            } 
        }  
        if(this.options.cursor){
            this.slider.querySelector(".slider-cursor .current").innerHTML = this.currentSlide + 1;
        }
        let translateX = -(this.sizeSlide * this.currentSlide ); 

 
        this.slider.querySelector(this.options.class_parent_slider).style.transition = this.saveTransition;
        this.slider.querySelector(this.options.class_parent_slider).style.transform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
        this.slider.querySelector(this.options.class_parent_slider).style.WebkitTransform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 


        if(this.bullets.length > 0){
            this.slider.querySelector(".bullet.active").classList.remove("active");
            this.bullets[this.currentSlide].classList.add("active");
            if(this.slider.closest(".content-valeurs")){
                this.slider.querySelector(".slide.active").classList.remove("active");
                this.slider.querySelectorAll(".slide")[this.currentSlide].classList.add("active"); 
            }  
            if(this.slider.closest(".content-landing-slider")){
                this.slider.querySelector(".slide.active").classList.remove("active");
                this.slider.querySelectorAll(".slide")[this.currentSlide].classList.add("active"); 
            }  
        }   
    } 

    reset(){
        //this.currentSlide = 0;
        //this.gotoStep(0);  
        let translateX = -(this.sizeSlide * this.currentSlide );  
        this.slider.querySelector(this.options.class_parent_slider).style.transition = "none";
        this.slider.querySelector(this.options.class_parent_slider).style.transform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
        this.slider.querySelector(this.options.class_parent_slider).style.WebkitTransform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
    }

    get sizeSlide() { 
        return this.slider.querySelectorAll(this.options.class_child)[0].offsetWidth;
    }

    get sizeWindow() {
        return window.innerWidth;
    }

    get slidesVisible(){ 
        if(this.sizeWindow < this.options.ruptDeskMob){
            return this.options.slideMob;
        }else{
            return this.options.slideDesk;
        } 
    }

    get inc(){ 
        if(this.sizeWindow < this.options.ruptDeskMob){
            return this.options.slideMobInc;
        }else{
            return this.options.slideDeskInc;
        } 
    }
}  
